<template>
  <el-container class="wrapper">
    <el-header class="header-el" height="64px">
      <v-head></v-head>
    </el-header>
    <!-- 左侧导航 -->
    <el-container class="content-box">
      <v-sidebar></v-sidebar>
      <el-main class="main-el">
        <div class="tag">
          {{ $lang(firstTitle) }}
        </div>
        <div class="content">
          <transition name="move" mode="out-in">
            <keep-alive :include="tagsList" exclude="catchList">
              <router-view></router-view>
            </keep-alive>
          </transition>
          <el-backtop target=".content"></el-backtop>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import vHead from "./Header.vue";
import vSidebar from "./Sidebar.vue";
import bus from "./bus";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tagsList: [],
      firstTitle: this.$route.meta.title,
      secendTitle: ""
    };
  },
  components: {
    vHead,
    vSidebar
  },
  watch: {
    $route: {
      handler(newValue) {
        if (newValue.path === '/home') {
          this.firstTitle = `Welcome back，${this.user.name || ''}`
        } else {
          this.firstTitle = newValue.meta.title
        }
      },
      // 初始化的时候执行
      immediate: true
    }
  },
  created() {
    //   页签
    bus.$on("routerTitle", (msg) => {
      const list = this.$store.state.base.menuList;
      list.map((message) => {
        if (message.childs) {
          message.childs.map((item) => {
            if (item.path == msg[0]) {
              this.firstTitle = item.name
            }
          })
        }
      })
    });
    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on("tags", (msg) => {
      const arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }
      this.tagsList = arr;
      localStorage.setItem("tagListView", JSON.stringify(msg));
    });
  },
  computed: {
    ...mapGetters(["user"])
  }
};
</script>
<style lang="scss" scoped>
.header-el {
  padding: 0;
  background: #8b2a2a;
}
.main-el {
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  @include scrollBarStyle();
}
.content {
  flex: 1;
  overflow: auto;
  // min-width: 1200px;

  @include scrollBarStyle();
}
.tag {
  width: auto;
  height: 14px;
  opacity: 1;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #999999;
  line-height: 14px;
  padding-bottom: 16px;
  span {
    color: #272727;
  }
}
</style>
